//welcome.js
import { useEffect, useState } from 'react';
import { getMethod } from '../services/apiService';
import LoadingSpinner from '../utility/LoadingSpinner';

const Welcome = () => {
  const [latestEntry, setLatestEntry] = useState({
    title:'',
    description:''
  });
  const [loading, setLoading] = useState(true);

  //Display welcome content
  useEffect(() => {
    const getWelcome = async () => {
      try {
        const response = await getMethod('welcome');
        if (!response.error && response.data) {
          const data = response.data;
          if (Array.isArray(data) && data.length > 0) {
            const lastItem = data[data.length - 1];
            setLatestEntry(lastItem);
            localStorage.setItem('welcomeContent', JSON.stringify(lastItem));
          } else if (data.title && data.description) {
            setLatestEntry(data);
            localStorage.setItem('welcomeContent', JSON.stringify(data));
          }
        } else {
          const storedContent = localStorage.getItem('welcomeContent');
          if (storedContent) {
            setLatestEntry(JSON.parse(storedContent));
          }
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching welcome content:', error);
        const storedContent = localStorage.getItem('welcomeContent');
        if (storedContent) {
          setLatestEntry(JSON.parse(storedContent));
        }
      }
    };

    getWelcome();
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      <section >
        <h1 className="welcomeheaderh1"
          dangerouslySetInnerHTML={{ __html: latestEntry.title }}>
        </h1>

      </section>

      <section>
        <div className="welcomecontentdiv"
          dangerouslySetInnerHTML={{ __html: latestEntry.description }}
        />
      </section>
    </div>
  );
};

export default Welcome;